import React, { useEffect } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
function ConfirmationModal(props){
    const [open, setOpen] = React.useState(props.open);
    useEffect(()=>{
        if(props.open){
            setOpen(props.open)
        }
    },[props])
    const handleClose = () => {
        setOpen(false)
        props.handleClose();
      };

    const handleConfirm = () => {
        handleClose()
        props.handleYes()
    }
    return(
        <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        {/* <DialogTitle>{"Use Google's location service?"}</DialogTitle> */}
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {props.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className='theme-btn' onClick={()=>handleConfirm()}>Yes</Button>
          <Button className='theme-btn cancel-btn' onClick={handleClose}>No</Button>
        </DialogActions>
      </Dialog>
    )
}
export default ConfirmationModal;